export const getLaborTypesSelector = state => state?.laborTypes
